import { render, staticRenderFns } from "./CommonHairdressingDigest.vue?vue&type=template&id=4be2b5f0&scoped=true&"
import script from "./CommonHairdressingDigest.vue?vue&type=script&lang=js&"
export * from "./CommonHairdressingDigest.vue?vue&type=script&lang=js&"
import style0 from "./CommonHairdressingDigest.vue?vue&type=style&index=0&lang=less&"
import style1 from "./CommonHairdressingDigest.vue?vue&type=style&index=1&id=4be2b5f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be2b5f0",
  null
  
)

export default component.exports